








































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import PlayerHelper, { PlayerHelperEvent, PlayState } from '@packages/player/PlayerHelper'
import LearningCourseModule from '@api/module/customer/learning/LearningCourseModule'
import LearningMedia from '@api/model/learning/LearningMedia'
import LearningCourseWare from '@api/model/learning/LearningCourseWare'
import { LeaningErrorCode } from '@api/model/learning/LearningResponse'

@Component
export default class extends Vue {
  get learningIntervalTime() {
    return LearningCourseModule.learningIntervalTime
  }

  async doLearningWithEvent(params: { mediaSchedule: number; currentMediaTimeLength: number; playState: number }) {
    await LearningCourseModule.doLearningWithEvent(params)
  }

  get learningMode() {
    return LearningCourseModule.learningMode
  }

  get isChangePolicy() {
    return LearningCourseModule.isChangePolicy
  }

  get isMustRefresh() {
    return LearningCourseModule.isMustRefresh
  }

  playerHelper: PlayerHelper = new PlayerHelper({})
  @Prop({
    type: LearningCourseWare,
    default() {
      return new LearningCourseWare()
    }
  })
  learningCourseWare: LearningCourseWare

  @Prop({
    type: Boolean,
    default: true
  })
  isVideoPlaying: boolean

  @Prop({
    type: Object,
    default: new LearningMedia()
  })
  learningMedia: LearningMedia

  @Watch('isMustRefresh')
  async isMustRefreshChange() {
    await this.playerHelper.doRefreshTip()
  }

  @Watch('isChangePolicy')
  async isChangePolicyChange() {
    this.playerHelper.learningIntervalTime = this.learningIntervalTime
  }

  @Watch('learningMedia.mediaId')
  initSuccessGoLearn() {
    this.playerHelper.learningIntervalTime = this.learningIntervalTime
    this.playerHelper.learningMode = this.learningMode
    this.playerHelper.changeMedia(this.learningMedia)
  }

  get formatSchedule() {
    return this.$moment.duration(this.learningMedia.lastMediaPlayScale, 'seconds').format('HH:mm:ss', {
      trim: false
    })
  }

  destroyed() {
    this.playerHelper.destroy()
  }

  @Watch('isVideoPlaying')
  playingTypeChange() {
    this.playerHelper.setCurrentPlayerType(this.isVideoPlaying)
    this.playerHelper.changeMedia(this.learningMedia)
  }

  private async doSaveSchedule(schedule: number, currentTime: number, playState: PlayState) {
    try {
      await this.doLearningWithEvent({
        mediaSchedule: schedule,
        currentMediaTimeLength: currentTime,
        playState: playState
      })
    } catch (e) {
      const code = `${e.message.code}`
      if (code === LeaningErrorCode.LEARNING_OTHER_COURSE || code === LeaningErrorCode.LEARNING_IN_OTHER) {
        this.playerHelper.player.stop()
        this.playerHelper.stop()
        try {
          await this.$alert(
            `
              您已打开新的播放页面。
              <br/>
              如需在本页面继续学习请刷新当前页面。
            `,
            '友情提示',
            {
              dangerouslyUseHTMLString: true,
              showClose: false,
              confirmButtonText: '刷新并继续在当前页面学习'
            }
          )
          window.location.reload()
        } catch (e) {
          console.log(e)
        }
      } else {
        this.$message({
          type: 'error',
          message: e.message.message
        })
      }
    }
  }

  async created() {
    await this.playerHelper.init()
    this.playerHelper.on(PlayerHelperEvent.commit, ({ schedule, currentTime, playState }) => {
      if (!schedule) return
      this.doSaveSchedule(schedule, currentTime, playState)
    })

    this.playerHelper.on(PlayerHelperEvent.end, ({ schedule, currentTime, playState }) => {
      this.doSaveSchedule(schedule, currentTime, playState)
      this.playerHelper.stop()
      this.$emit(PlayerHelperEvent.end)
    })
  }

  async saveSchedule() {
    try {
      if (!this.playerHelper.player.getSchedule()) return
      await this.doLearningWithEvent({
        mediaSchedule: this.playerHelper.player.getSchedule(),
        currentMediaTimeLength: this.playerHelper.player.getTime(),
        playState: PlayState.pause
      })
    } catch (e) {
      this.$message({
        type: 'error',
        message: e.message.message
      })
    }
  }
}
